import { AfterViewChecked, ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Injector, Input, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';
import { SeraDropdownOption } from '../../models/SeraDropdownOption';

@Component({
    selector: 'sera-dropdown',
    templateUrl: './sera-dropdown.component.html',
    styleUrls: ['./sera-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraDropdownComponent),
            multi: true
        }
    ],
    standalone: false
})

//For more documentation, refer to PrimeNG doc on dropdowns (fields here mirror properties of p-select).
export class SeraDropdownComponent extends ValueAccessor<any> implements AfterViewChecked {
    @ViewChild(NgModel)
    private readonly model?: NgModel;

    constructor(injector: Injector) {
        super(injector);
    }

    override writeValue(value: unknown): void {
        this.model?.control.setValue(value, { emitEvent: false, emitViewToModelChange: false });
        super.writeValue(value);
    }

    @Input()
    required: boolean = false;

    @Input()
    isDisabled: boolean = false;

    @Input()
    readOnly: boolean = false;

    @Input()
    showClear: boolean = true;

    @Input()
    options: SeraDropdownOption[] = [];

    @Input()
    isFiltered: boolean = true;

    @Input()
    filterValue: string | undefined;

    @Input()
    filterBy: string = 'name';

    //Defines how the items are filtered, valid values are "contains" (default) "startsWith", "endsWith", "equals", "notEquals", "in", "lt", "lte", "gt" and "gte".
    @Input()
    filterMatchMode: 'contains' | 'startsWith' | 'endsWith' | 'equals' | 'notEquals' | 'in' | 'lt' | 'lte' | 'gt' | 'gte' = 'contains';

    @Input()
    filterPlaceholder: string | undefined;

    @Input()
    isVirtualScroll: boolean = true;

    @Input()
    virtualItemSize: number = 30;

    @Input()
    style: {} = { width: '100%' };

    @Input()
    styleClass: string = '';

    @Input()
    panelStyleClass: string = '';

    @Input()
    emptyMessage: string | undefined;

    @Input()
    emptyFilterMessage: string | undefined;

    @Input()
    dropdownIcon: string = 'pi pi-chevron-down';

    @Input()
    label: string | undefined;

    @Input()
    inputId: string | undefined;

    scrollHeight: string = '200px';

    @Input()
    placeholder: string | undefined;

    @Output() selectionChanged = new EventEmitter<any>();

    ngAfterViewChecked() {
        this.scrollHeight = this.getScrollHeightForUnfilteredOptions();
    }

    getScrollHeightForUnfilteredOptions(): string {
        const itemHeight = this.isFiltered ? 28 : 30;
        const maxHeight = 200;
        const calculatedHeight = this.options?.length * itemHeight;

        return calculatedHeight > maxHeight ? `${maxHeight}px` : `${calculatedHeight}px`;
    }
}
